import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "热门分类",
    links: [
      { name: "企业内幕", path: "/category/corporate-insider" },
      { name: "金融黑幕", path: "/category/financial-scandal" },
      { name: "娱乐揭秘", path: "/category/entertainment-expose" },
      { name: "社会民生", path: "/category/society-livelihood" },
      { name: "消费陷阱", path: "/category/consumer-trap" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { name: "品牌介绍", path: "/about" },
      { name: "用户口碑", path: "/about#testimonials" },
      { name: "联系方式", path: "/about#contact" },
      { name: "发展历程", path: "/about#milestones" },
    ],
  },
  {
    title: "用户指南",
    links: [
      { name: "如何爆料", path: "/about" },
      { name: "内容规范", path: "/about" },
      { name: "隐私保护", path: "/about" },
      { name: "社区准则", path: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="container-custom py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-spy-fill text-xl text-primary-500"></i>
              </div>
              <span className="font-heading font-bold text-lg text-foreground-100">
                黑料社区
              </span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed mb-4">
              专注于深度内幕、真实情报与用户自发揭秘的聚合社区平台。发现被隐藏的真相，掌握第一手情报资讯。
            </p>
            <div className="flex items-center gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-telegram-line", "ri-twitter-x-line"].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#"
                    rel="nofollow"
                    className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/50 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer"
                    aria-label="社交媒体"
                  >
                    <i className={`${icon} text-lg`}></i>
                  </a>
                )
              )}
            </div>
          </div>

          {/* Link Columns */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-foreground-200 text-sm mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-foreground-500 hover:text-primary-400 text-sm transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between pt-10 mt-10 border-t border-background-200/40 gap-4">
          <p className="text-foreground-600 text-xs">
            &copy; {new Date().getFullYear()} 黑料社区 Heiliao Community. 保留所有权利。
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-600 hover:text-foreground-300 text-xs transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-600 hover:text-foreground-300 text-xs transition-colors" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-foreground-600 hover:text-foreground-300 text-xs transition-colors" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}